export default class Endpoints {
  static PROD_API_ENDPOINT =
    'https://sf5gzadv3l.execute-api.us-west-2.amazonaws.com/prod/api';
  static STAGING_API_ENDPOINT =
    'https://oerlc1nhvb.execute-api.us-west-2.amazonaws.com/staging/api';
}
